import React, { useEffect } from 'react';
import './SponsorBanner.css';
import { MEDIA_URL } from '../../utils/constants';

function SponsorBanner({ logosList }) {
  useEffect(() => {
    const logosSlide = document.querySelector(".logos-slide");
    if (logosSlide) {
      const copy = logosSlide.cloneNode(true);
      document.querySelector(".logos").appendChild(copy);
    }
  }, [logosList]);

  if (!logosList || logosList.length === 0) {
    return null;
  }

  let extendedLogosList = [...logosList];
  while (extendedLogosList.length < 10) {
    extendedLogosList = [...extendedLogosList, ...logosList];
  }

  return (
    <div className="logos">
      <div className="logos-slide">
        {extendedLogosList.map((item, index) => (
          <img key={index} src={MEDIA_URL + item} alt={`Sponsor logo ${index}`} />
        ))}
      </div>
    </div>
  );
}

export default SponsorBanner;
